module.exports = __webpack_public_path__ + "img/pr-49.741e97ba.png";